import PropTypes from 'prop-types';
import React from 'react';

import { ElementShape } from '../../constants';

import Avatar from './Avatar';


const RoundAvatar = ({ alt, size, src, sx }) => (
  <Avatar
    alt={alt}
    shape={ElementShape.ROUND}
    size={size}
    src={src}
    sx={sx}
  />
);

RoundAvatar.propTypes = {
  alt: PropTypes.string.isRequired,
  size: PropTypes.number,
  src: PropTypes.string.isRequired,
  sx: PropTypes.shape({}),
};

RoundAvatar.defaultProps = {
  size: undefined,
  sx: {},
};


export default RoundAvatar;
